import { useContext } from 'react';

import type { FilterContextType } from './filter.types';
import { FilterContext } from './FilterContextBase';

export const useFilter = (): FilterContextType => {
  const context = useContext(FilterContext);
  if (context === undefined) {
    throw new Error('useFilter must be used within a FilterProvider');
  }
  return context;
};
